export default {
  "type": "form",
  "tags": [],
  "owner": "5b880606acd5b553f1ad58ea",
  "components": [
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Company Name",
      "key": "vendorName",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {},
      "lockKey": true
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Address",
      "key": "address",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "City",
      "key": "city",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "State",
      "key": "state",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Zipcode",
      "key": "zip",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {},
      "lockKey": true
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "tel",
      "inputMask": "(999) 999-9999",
      "label": "Phone",
      "key": "phone",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "defaultValue": "",
      "clearOnHide": true,
      "validate": {
        "required": false
      },
      "type": "phoneNumber",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "email",
      "label": "Email",
      "key": "email",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "kickbox": {
        "enabled": false
      },
      "type": "email",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Website",
      "key": "website",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "spellcheck": true,
      "validate": {
        "required": false,
        "minLength": "",
        "maxLength": "",
        "pattern": "",
        "custom": "",
        "customPrivate": false
      },
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "type": "textfield",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "properties": {}
    },
    {
      "autofocus": false,
      "input": true,
      "label": "Submit",
      "tableView": false,
      "key": "submit",
      "size": "md",
      "leftIcon": "",
      "rightIcon": "",
      "block": false,
      "action": "submit",
      "disableOnInvalid": false,
      "theme": "primary",
      "type": "button"
    }
  ],
  "revisions": "",
  "_vid": 0,
  "_id": "5bb2819fa0f3b4eda06af9ed",
  "title": "VendorEdit",
  "display": "form",
  "access": [
    {
      "roles": [
        "5b88072cacd5b53313ad5918",
        "5b88072cacd5b5f747ad5919",
        "5b88072cacd5b55293ad591a"
      ],
      "type": "read_all"
    }
  ],
  "submissionAccess": [],
  "settings": {},
  "name": "vendorEdit",
  "path": "vendoredit",
  "project": "5b88072cacd5b53c66ad5917",
  "created": "2018-10-01T20:20:47.967Z",
  "modified": "2018-10-23T15:44:24.806Z",
  "machineName": "irlxqknnoqiregk:vendorEdit"
}